<script setup lang="ts">
import { useSpNotificationStore } from '@/SP/store/NotificationStore';
import { useBannerABTest } from '@/common/composables/useBannerABTest';
import { storeToRefs } from 'pinia';
import { onMounted } from 'vue';

const store = useSpNotificationStore()
const { bottomPosition } = storeToRefs(store)
const { variant, trackImpression, trackClick } = useBannerABTest()

const nitteUrl = `https://nitte.ai/?utm_source=text-gen&utm_medium=referral&utm_campaign=launch&utm_content=toast&mp_distinct_id=${window.mixpanel?.get_distinct_id?.() ?? ''}`

onMounted(() => {
  trackImpression()
})
</script>

<template>
  <div class="notification-wrapper" :style="{ bottom: bottomPosition.toPx() }">
    <div class="copy-notification">
      <div class="check-icon">
        <svg width="13" height="13" viewBox="0 0 14 14" fill="none"><path d="M2 7l4 4 6-6" stroke="#1D9E75" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </div>
      <div class="text-content">
        <div class="title">コピーしました</div>
        <div v-if="variant === 'A'" class="subtitle">AIで日程調整をもっと楽にしませんか？</div>
        <div v-else class="subtitle">作る君開発者がおくるAI日程調整アプリ</div>
      </div>
      <a :href="nitteUrl" target="_blank" rel="noopener noreferrer" class="cta-button" @click="trackClick">
        <template v-if="variant === 'A'">
          もっと楽に
        </template>
        <template v-else>
          Nitte.AI
        </template>
        <svg width="11" height="11" viewBox="0 0 12 12" fill="none"><path d="M2 6h8M7 3l3 3-3 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </a>
    </div>
  </div>
</template>

<style scoped>
.notification-wrapper {
  position: fixed;
  width: 100%;
  padding: 16px;
  z-index: 120;
}
.copy-notification {
  background: linear-gradient(160deg, #f7faf8 0%, #eef6f1 100%);
  border: 1px solid #d8ebe1;
  border-radius: 14px;
  padding: 14px 18px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 4px 20px rgba(29, 158, 117, 0.12);
}
.check-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(29, 158, 117, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.text-content {
  flex: 1;
  min-width: 0;
  text-align: left;
}
.title {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a18;
}
.subtitle {
  font-size: 12px;
  color: #7a7870;
  margin-top: 2px;
}
.cta-button {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #1D9E75;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  border-radius: 6px;
  padding: 7px 14px;
  border: none;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  text-decoration: none;
  transition: background 0.2s ease;
}
.cta-button:hover {
  background: #178a66;
}
</style>
